export class SearchHistoryStorage {
  private LS_KEY = 'agents_search_history_storage';
  private MAX_HISTORY_SIZE = 5;

  /**
   * Хранилище элементов истории, зеркальное для LocalStorage.
   * Изменения сначала производятся над storage, а затем синхронизируются в LocalStorage
   * */
  private readonly storage: Set<string>;

  public constructor() {
    this.storage = this.parseStorageFromLs() || new Set<string>();
  }

  private initLs() {
    /* istanbul ignore else */
    if (this.isLsAvailable) {
      window.localStorage.setItem(this.LS_KEY, JSON.stringify([]));
    }
  }

  private parseStorageFromLs() {
    try {
      /* istanbul ignore if */
      if (!this.isLsAvailable) {
        return null;
      }

      const storageStringVal = window.localStorage.getItem(this.LS_KEY);

      /** Если в LS пусто, нужно проинициализировать пустым списком */
      if (!storageStringVal) {
        this.initLs();

        return null;
      }

      const parsedStorageVal = JSON.parse(storageStringVal);

      if (Array.isArray(parsedStorageVal)) {
        const preparedStorage = new Set<string>();

        parsedStorageVal.forEach(el => {
          preparedStorage.add(el);
        });

        return preparedStorage;
      }

      return null;
    } catch (e) /* istanbul ignore next */ {
      if (this.isLsAvailable) {
        window.localStorage.removeItem(this.LS_KEY);
      }

      return null;
    }
  }

  private get isLsAvailable() {
    return typeof window !== 'undefined' && 'localStorage' in window;
  }

  private updateLocalStorage() {
    /* istanbul ignore else */
    if (this.isLsAvailable) {
      window.localStorage.setItem(this.LS_KEY, JSON.stringify(this._list));
    }
  }

  private get _list() {
    return Array.from(this.storage);
  }

  /**
   * Основной метод для добавления нового элемента в хранилище
   * */
  public add(item: string) {
    this.storage.add(item);

    if (this.storage.size > this.MAX_HISTORY_SIZE) {
      this.storage.delete(this._list[0]);
    }

    this.updateLocalStorage();

    return this;
  }

  /**
   * Основной метод для получения списка в виде Array
   * reverse для того, чтоб последний добавленный элемент был под индексом 0 (вверху списка)
   * */
  public get list() {
    return this._list.reverse();
  }
}
